import { usePage } from '@consumer/composables/sharedData'

export function useIsPdfCapture () {
  const page = usePage()
  return computed(() => !!(page.props as Record<string, unknown>).pdfCapture)
}
